export const UNKNOWN_ERROR_MSG = 'Системна помилка.';
export const LOST_CONNECTION_MSG = 'Втрачено з\'єднання з сервером. Зачекайте, поки знайдеться доступний сервер…';
export const LOST_CONNECTION_TOTALY_MSG = 'Втрачено з\'єднання з сервером.';
export const SERVER_ERROR_MSG = 'На серверах телефонії виникла помилка.';
export const SERVER_NOT_RESPONSE_MSG = 'Сервер телефонії не відповідає. ';